(function () {
  // this sets automatic heights for text elements in grid
  function setElementAutoHeights() {
    const els = document.querySelectorAll('[data-masonry-auto-height]');
    els.forEach((el) => {
      const { height } = el.children[0].getBoundingClientRect();
      // calculate minumum number of spans needed for element content
      const totalHeight = height + 36;
      const spans = Math.ceil(totalHeight / 36);
      el.style.gridRow = `span ${spans}`;
    });
  }

  function getSpanInt(el) {
    const n = parseInt(getComputedStyle(el).gridRowStart.replace('span ', ''), 10);
    if (Number.isNaN(n)) {
      return 0;
    }
    return n;
  }

  // set the height of items in final row of grid
  function setFinalRowHeight() {
    const count = window.innerWidth > 767 ? 5 : 2;
    const grids = document.querySelectorAll('.masonry-image-grid');
    grids.forEach((g) => {
      const items = g.querySelectorAll('.masonry-image-grid__image');
      // reset inline style for gridrow
      items.forEach((item) => (item.style.gridRow = null));
      const last = Array.from(items).slice(items.length - count);

      // figure out if any items are in line with end of parent grid
      const unaligned = last.filter(
        (l) => l.getBoundingClientRect().bottom !== g.getBoundingClientRect().bottom,
      );

      // calculate difference between bottom of el and bottom of parent in spans
      unaligned.forEach((u) => {
        const diff = g.getBoundingClientRect().bottom - u.getBoundingClientRect().bottom;
        const spans = diff / 36 + getSpanInt(u);
        // set spans style prop
        u.style.gridRow = `span ${spans}`;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', setElementAutoHeights);
  document.addEventListener('DOMContentLoaded', setFinalRowHeight);
  window.addEventListener('resize', setElementAutoHeights);
  window.addEventListener('resize', setFinalRowHeight);
})();

// handle modal interactions
(function () {
  function imgUrl(url, size) {
    const { index } = url.match(/\.(png|jpg|jpeg|gif|webp)/);
    if (!index) return url;
    const u = url.slice(0, index);
    const r = size ? `_${size}x` : '';
    const l = url.slice(index);
    return `${u}${r}${l}`;
  }

  function handleModalTriggerClick(e) {
    if (e.target.dataset.galleryModalImageSrc) {
      // set src on img in modal
      const galleryModal = document.getElementById('gallery-modal');
      const loader = galleryModal.querySelector('.gallery-modal__loader');
      const content = galleryModal.querySelector('.gallery-modal__content');
      const img = galleryModal.querySelector('img');
      const attribution = galleryModal.querySelector('.gallery-modal__attribution');

      const { galleryModalImageHeight, galleryModalImageWidth } = e.target.dataset;

      // prep modal for loading state
      loader.classList.remove('hide');
      content.classList.add('hide');
      window.MicroModal.show('gallery-modal');

      // add one time listener to trigger modal after image load
      img.addEventListener(
        'load',
        () => {
          img.classList.add('loaded');
          img.closest('[data-micromodal-close]').focus();
          img.setAttribute('tabindex', '0');
          setTimeout(() => {
            loader.classList.add('hide');
            content.classList.remove('hide');
          }, 300);
        },
        { once: true },
      );

      // blank out src to remove old image before load
      img.src = '';
      img.srcset = '';

      img.src = e.target.dataset.galleryModalImageSrc;
      img.srcset = `
      ${imgUrl(e.target.dataset.galleryModalImageSrc, 300)} 300w,
      ${imgUrl(e.target.dataset.galleryModalImageSrc, 600)} 600w,
      ${imgUrl(e.target.dataset.galleryModalImageSrc, 800)} 800w,
      ${imgUrl(e.target.dataset.galleryModalImageSrc, 1000)} 1000w,
      ${imgUrl(e.target.dataset.galleryModalImageSrc, 1200)} 1200w,
      ${imgUrl(e.target.dataset.galleryModalImageSrc, 1440)} 1440w
      `;

      // set attribution
      const { galleryModalPhotographer, galleryModalCaption } = e.target.dataset;
      const photographerEls = galleryModal.querySelectorAll('[data-gallery-modal-photographer]');

      // set img alt
      img.alt = galleryModalCaption ?? galleryModalPhotographer;

      photographerEls.forEach(
        (el) =>
          (el.innerText = galleryModalPhotographer
            ? `Photographer: ${galleryModalPhotographer}`
            : ''),
      );

      const captionEls = galleryModal.querySelectorAll('[data-gallery-modal-caption]');
      captionEls.forEach((el) => (el.innerText = galleryModalCaption || ''));

      if (!e.target.dataset.galleryModalPhotographer && !e.target.dataset.galleryModalCaption) {
        attribution.classList.add('hide');
      } else {
        attribution.classList.remove('hide');
      }
    }
  }

  document.addEventListener('click', handleModalTriggerClick);
})();
